import dayjs from 'dayjs';

import defaultBingoBoardImg from '../../assets/bingo/bingo_board_social.webp';
import type { MetagameTokenPackageBundle } from '../../dto/metagames.types';

import type { SubscriptionCoinType, SubscriptionCycleType, SubscriptionPlanEnhanced, UserSubscription } from './types';

const CYCLE_DAYS: Record<SubscriptionCycleType, number> = {
  daily: 1,
  weekly: 7,
  monthly: 30,
  yearly: 365,
};

export class SubscriptionUtils {
  static getCardsCounts(packageBundles: MetagameTokenPackageBundle[], coinType?: SubscriptionCoinType): number {
    return packageBundles
      .filter(
        (bundle) => bundle.bundleType === 'metagameToken' && (!coinType || bundle.bundlePayload.coinType === coinType),
      )
      .reduce((total, bundle) => total + Number(bundle.bundlePayload.amount), 0);
  }

  static getCurrencySymbol(packageBundles: MetagameTokenPackageBundle[], coinType: SubscriptionCoinType): string {
    const packageBundle = packageBundles.find(
      (bundle) => bundle.bundleType === 'metagameToken' && bundle.bundlePayload.coinType === coinType,
    );
    return packageBundle?.bundlePayload.currencySymbol || defaultBingoBoardImg;
  }

  static getCardsInfo(packageBundles: MetagameTokenPackageBundle[]): {
    gcCards: number;
    scCards: number;
    gcSymbol: string;
    scSymbol: string;
  } {
    return {
      gcCards: this.getCardsCounts(packageBundles, 'GC'),
      scCards: this.getCardsCounts(packageBundles, 'CASH'),
      gcSymbol: this.getCurrencySymbol(packageBundles, 'GC'),
      scSymbol: this.getCurrencySymbol(packageBundles, 'CASH'),
    };
  }

  static checkIfHigherTierPlanExists(availablePlans: SubscriptionPlanEnhanced[], currentPlanPrice: number): boolean {
    const higherTierPlan = availablePlans.find((plan) => plan.price > currentPlanPrice);
    return !!higherTierPlan;
  }

  static calculateUpgradeCharge(currentSubscription: UserSubscription, newPlanPrice: number): number {
    const daysLeft = Math.max(0, dayjs(currentSubscription.nextBillingDate).diff(dayjs(), 'days'));
    const cycleDays = CYCLE_DAYS[currentSubscription.plan.cycleType] ?? 30;
    const leftCreditCents = ((currentSubscription.plan.price * 100) / cycleDays) * daysLeft;
    return Math.max(0, Math.floor(newPlanPrice * 100 - leftCreditCents)) / 100;
  }
}
